import React from 'react'
import PropTypes from 'prop-types'
import gql from 'graphql-tag'
import { Carousel } from 'react-responsive-carousel'

import 'react-responsive-carousel/lib/styles/carousel.min.css'

const GalleryParagraph = ({ media }) => {
  const images = media.entity.images

  return (
    !!images.length && (
      <>
        <Carousel showThumbs={false} showStatus={false}>
          {images.map(image => (
            <div key={image.entity.image.url}>
              <img
                alt={image.entity.image.alt}
                title={image.entity.image.title}
                src={image.entity.image.url}
              />
            </div>
          ))}
        </Carousel>
      </>
    )
  )
}

GalleryParagraph.propTypes = {
  media: PropTypes.shape({
    entity: PropTypes.shape({
      images: PropTypes.array,
    }),
  }),
}

const fragments = {
  paragraph: gql`
    fragment GalleryParagraphFragment on ParagraphGallery {
      id
      media: fieldMedia {
        entity {
          ... on MediaGallery {
            images: fieldMediaImages {
              targetId
              entity {
                image: thumbnail {
                  alt
                  title
                  url
                }
              }
            }
          }
        }
      }
      description: fieldParagraphDescription {
        value
      }
      caption: fieldParagraphCaption {
        value
      }
      credits: fieldParagraphCredits {
        value
      }
      creditsLabel: fieldParagraphCreditsLabel
      avaliableTeacherOnly: fieldAvailableTeacherOnly
    }
  `,
}

export { GalleryParagraph, fragments }
